import { h } from "preact";
import { route } from "preact-router";
import Button from "../../components/button";
import Header from "../../components/header";
import { withStore } from "../../store";

export const ServerUnreachableError = withStore(({ store }) => {
  const { theme } = store.state;

  return (
    <div
      className={
        "first-layer h-full flex flex-col align-center justify-between"
      }
    >
      <div>
        <Header>Unreachable Server</Header>
      </div>
      <div className={"text-center"}>
        <div className={"text-normal font-black text-center"}>
          Server is not reachable.
        </div>
      </div>
      <div className={"px-2 my-7 w-full flex justify-center"}>
        <Button
          text={"Back to Home"}
          gradient
          backgroundColor={theme === "dark" && theme}
          bottom_float
          onClick={() =>
            setTimeout(() => {
              route("/home");
            })
          }
        />
      </div>
    </div>
  );
});
